import type { ReactNode } from 'react'

export type PageShellProps =
  | { variant: 'legal'; bodyHtml: string }
  | { variant: 'help'; children: ReactNode }
  | { variant: 'helpIndex'; children: ReactNode }

// Shared Chalk & Paper shell for the legal pages (privacy/terms) and the two help routes — the
// `.wrap.{legal|help}` layout and the `legal-home`/`legal-mark` home link were byte-identical
// between LegalPage and HelpPageShell (code-rule.md DRY — Rule of Two: LegalPage's privacy/terms
// pair was already the second instance when HelpPageShell forked the same shell again). Both
// help routes share the `.help` sizing class on `main` — `helpIndex` still maps to it — but get
// their own inner container: `help` for the article (`.help-body`'s prose typography) and
// `helpIndex` for the index (`.help-index-body`), so the index's card list never inherits
// `.help-body strong`'s ink color, which is what made a card title read as static bold text
// instead of a link when the index used to borrow the article's container.
//
// `bodyHtml` sets trusted static content straight onto `.legal-body` via dangerouslySetInnerHTML
// (LegalPage's shape); `children` renders composed JSX inside the variant's own container
// (HelpPageShell's shape). Kept as separate prop shapes rather than one `children`-always API so
// no call site gains an extra wrapping element — that would push the first paragraph a level
// deeper and break brand.css's `.legal-body > p:first-of-type` direct-child selector.
export const PageShell = (props: PageShellProps) => (
  <main className={`wrap ${props.variant === 'legal' ? 'legal' : 'help'}`}>
    <a className="legal-home" href="/">
      <span className="legal-mark" aria-hidden="true">
        <img src="/assets/img/quickscore-logo.svg" alt="" width={30} height={30} />
      </span>
      QuickScore
    </a>
    {props.variant === 'legal' && <div className="legal-body" dangerouslySetInnerHTML={{ __html: props.bodyHtml }} />}
    {props.variant === 'help' && <div className="help-body">{props.children}</div>}
    {props.variant === 'helpIndex' && <div className="help-index-body">{props.children}</div>}
  </main>
)
